import { type ComponentProps, type JSXElementConstructor } from "react";
import classNames from "classnames";

export function withClass<T extends keyof JSX.IntrinsicElements | JSXElementConstructor<any>>(cls: string) {
  return (Tag: T) =>
    ({ className, ...rest }: ComponentProps<T>) => {
      // @ts-ignore
      return <Tag className={classNames(className, cls)} {...rest} />;
    };
}
